export default __webpack_public_path__ + "static/media/December2022.99c6cbb4.jpg";